import {
  type AssetDownloadAgreementsResponse,
  type DownloadAgreement,
} from '../../types/isomorphic/download.types';
import type { SubFamily } from '../../types/isomorphic/subscriptionClassification';
import { SUBSCRIPTION_AGREEMENT_SKU_PATTERNS } from '../../types/isomorphic/subscriptionClassification';

export const RF_SUBSCRIPTION_AGREEMENT_TYPE = 'RoyaltyFreeSubscription';

export const getRfSubscriptionAgreement = (
  downloadAgreements: AssetDownloadAgreementsResponse | null | undefined
): DownloadAgreement | undefined =>
  downloadAgreements?.agreements?.find(
    (a) => a.type === RF_SUBSCRIPTION_AGREEMENT_TYPE
  );

export const isAssetCoveredByRfSubscription = (
  downloadAgreements: AssetDownloadAgreementsResponse | null | undefined
): boolean => !!getRfSubscriptionAgreement(downloadAgreements);

export const hasRemainingDownloads = (
  rfAgreement: DownloadAgreement
): boolean => {
  const { agreementDetails } = rfAgreement;
  if (!agreementDetails) return false;
  return (
    agreementDetails.hasUnlimitedDownload ||
    agreementDetails.downloadCount < agreementDetails.downloadCapacity
  );
};

export const resolveSubFamilyFromAgreement = (
  agreement: DownloadAgreement
): SubFamily | undefined => {
  if (!agreement.sku) return undefined;
  const entries = Object.entries(SUBSCRIPTION_AGREEMENT_SKU_PATTERNS) as [
    SubFamily,
    RegExp
  ][];
  for (const [subFamily, skuPattern] of entries) {
    if (skuPattern.test(agreement.sku)) return subFamily;
  }
  return undefined;
};
